export const TRANSACTIONS_GET_REQUEST = "@transactions.get.request";
export const TRANSACTIONS_GET_SUCCESS = "@transactions.get.success";
export const TRANSACTIONS_GET_FAIL = "@transactions.get.failure";

export const TRANSACTION_LOAD_REQUEST = "@transaction.load.request";
export const TRANSACTION_LOAD_SUCCESS = "@transaction.load.success";
export const TRANSACTION_LOAD_FAIL = "@transaction.load.failure";

export const TRANSACTION_CREATE_REQUEST = "@transaction.create.request";
export const TRANSACTION_CREATE_SUCCESS = "@transaction.create.success";
export const TRANSACTION_CREATE_FAIL = "@transaction.create.failure";

export const TRANSACTION_UPDATE_REQUEST = "@transaction.update.request";
export const TRANSACTION_UPDATE_SUCCESS = "@transaction.update.success";
export const TRANSACTION_UPDATE_FAIL = "@transaction.update.failure";
